import React, { useEffect, useState } from "react";
import EditIcon from "@material-ui/icons/EditOutlined";
import DoneIcon from "@material-ui/icons/DoneAllTwoTone";
import RevertIcon from "@material-ui/icons/NotInterestedOutlined";
import "./TebleTemplet.scss";
import {
  TableRow, Paper, Table, TableBody, TableCell,
  TableContainer, TableHead, TablePagination,
  IconButton, Input, Box
} from "@mui/material";


const CustomTableCell = ({
  row,
  name,
  isColEdit,
  type,
  subColumns,
  onChange,
}) => {
  const { isEditMode } = row;
  return (
    <TableCell align="left" >
      {type === "table" ? (
        <table className="internal_table">
          <tbody >
            <tr>
              {subColumns.map((subCol) => {
                return <td key={subCol.id}>{subCol.label}</td>;
              })}
            </tr>
            {row[name].map((item, index) => {
              return (
                <tr key={index}>
                  {subColumns.map((subCol) => {
                    return (
                      <CustomTableCell
                        key={subCol.id}
                        {...{
                          row: item,
                          name: subCol.id,
                          isColEdit: subCol.edit,
                          type: subCol.type,
                          subColumns: null,
                          onChange,
                        }}
                      />
                    );
                  })}
                </tr>
              );
            })}
          </tbody>
        </table>
      ) : type === "image" ? (
        <Box className="img-box">
          <img src={row[name]}
            height={50} width={50}></img>
        </Box>
      ) : isEditMode && isColEdit && row.id !== "Amazon" ? (
        <Input
          sx={{ maxHeight: "35px" }}
          value={row[name]}
          name={name}
          type={type}
          onChange={(e) => onChange(e, row)}
        />
      ) : (
        row[name]
      )}
    </TableCell>
  );
};

const TableTemplete = ({ columns, data, saveChangesInDB }) => {
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [previous, setPrevious] = useState({});
  const [rows, setRows] = React.useState(data);
  const [colTableTypeId, setColTableTypeId] = useState(null);

  useEffect(() => {
    setRows(data);
    let columnsTable = columns.filter((col) => col.type === "table");
    if (columnsTable.length > 0) {
      setColTableTypeId(columnsTable[0].id);
    }
  }, [data]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const onToggleEditMode = (id, action) => {
    setRows((state) => {
      return rows.map((row) => {
        if (row.id === id) {
          if (action === "save") {
            saveChangesInDB(row);
            setPrevious({})
          }
          if (colTableTypeId) {
            return {
              ...row,
              isEditMode: !row.isEditMode,
              [colTableTypeId]: changeEditSubRows(row[colTableTypeId], row.id),
            };
          } else {
            return {
              ...row,
              isEditMode: !row.isEditMode,
            };
          }
        }
        return row;
      });
    });
  };

  const changeEditSubRows = (rows, parentId, isRevert = false) => {
    return rows.map((subRow) => {
      return {
        ...subRow,
        isEditMode: isRevert ? false : !subRow.isEditMode,
        isSub: true,
        parentId: parentId,
      };
    });
  };

  const onRevert = (id) => {
    const newRows = rows.map((row) => {
      if (row.id === id) {
        return previous[id]
          ? colTableTypeId
            ? {
              ...previous[id],
              isEditMode: !row.isEditMode,
              [colTableTypeId]: changeEditSubRows(
                previous[id][colTableTypeId],
                row.id,
                true
              ),
            }
            : { ...previous[id], isEditMode: !row.isEditMode }
          : colTableTypeId
            ? {
              ...row,
              isEditMode: !row.isEditMode,
              [colTableTypeId]: changeEditSubRows(
                row[colTableTypeId],
                row.id,
                true
              ),
            }
            : { ...row, isEditMode: !row.isEditMode };
      }
      return row;
    });

    setRows(newRows);
    setPrevious((state) => {
      delete state[id];
      return state;
    });
  };

  const onChange = (e, row) => {
    const RowId = row.isSub ? row.parentId : row.id;
    if (!previous[RowId]) {
      setPrevious((state) => ({
        ...state,
        [RowId]: row.isSub ? rows.filter((r) => r.id === row.parentId)[0] : row,
      }));
    }
    const value = e.target.value !== "" ? e.target.value : null;
    const name = e.target.name;
    const rowId = row.isSub ? row.parentId : row.id;
    let newRows = rows.map((rowMap) => {
      if (rowMap.id === rowId && !row.isSub) {
        return { ...rowMap, [name]: value };
      } else if (rowMap.id === rowId && row.isSub) {
        return {
          ...rowMap,
          [colTableTypeId]: rowMap[colTableTypeId].map((subRow) => {
            if (subRow.id === row.id) {
              return { ...subRow, [name]: value };
            } else {
              return subRow;
            }
          }),
        };
      }
      return rowMap;
    });
    setRows(newRows);
  };

  return (
    <Paper>
      <TableContainer sx={{ maxHeight: "440px" }}>
        <Table stickyHeader aria-label="sticky table">
          <TableHead>
            <TableRow>
              {columns.map((column) => (
                <TableCell
                  key={column.id}
                  style={{ minWidth: column.minWidth }}
                >
                  {column.label}
                </TableCell>
              ))}
              <TableCell >
                Actions
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows
              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map((row) => {
                return (
                  <TableRow hover role="checkbox" tabIndex={-1} key={row.id}>
                    {columns.map((column) => {
                      return (
                        <CustomTableCell
                          key={column.id}
                          {...{
                            row,
                            name: column.id,
                            isColEdit: column.edit,
                            type: column.type,
                            subColumns: column.subColumns,
                            onChange,
                          }}
                        />
                      );
                    })}
                    <TableCell>
                      {row.isEditMode ? (
                        <>
                          <IconButton
                            aria-label="done"
                            onClick={() => onToggleEditMode(row.id, "save")}
                          >
                            <DoneIcon />
                          </IconButton>
                          <IconButton
                            aria-label="revert"
                            onClick={() => onRevert(row.id)}
                          >
                            <RevertIcon />
                          </IconButton>
                        </>
                      ) : (
                        <IconButton
                          aria-label="delete"
                          onClick={() => onToggleEditMode(row.id, "edit")}
                        >
                          <EditIcon />
                        </IconButton>
                      )}
                    </TableCell>
                  </TableRow>
                );
              })}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        component="div"
        count={rows.length}
        page={page}
        onPageChange={handleChangePage}
        rowsPerPage={rowsPerPage}
        rowsPerPageOptions={[10, 25, 100]}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </Paper>
  );
};
export default TableTemplete;
